'use strict';

import { Dropdown } from "bootstrap";
import ScrollBarHelper from '../../../node_modules/bootstrap/js/src/util/scrollbar.js';

export default class OPLUtility {
    constructor() {
    }

    init() {
        this.setGlobalCSSVars();
        this.initCloseBootstrapDropdownButtons();
    }

    throttle(callback, delay = 1000) {
        let shouldWait = false;

        return (...args) => {
            if (shouldWait) return;

            callback(...args);
            shouldWait = true;
            setTimeout(() => {
                shouldWait = false;
            }, delay);
        }
    }

    debounce(callback, delay = 1000) {
        let timer;

        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                callback(...args);
            }, delay);
        }
    }

    initCloseBootstrapDropdownButtons() {
        // Bootstrap Dropdown doesn't have its dedicated dismiss button, adding our own treatment. 
        document.addEventListener('click', (e) => {
            if (e.target.hasAttribute('data-opl-bs-dropdown-close')) {
                const targetDropdownToggle = document.getElementById(e.target.dataset.oplBsDropdownClose);
                Dropdown.getOrCreateInstance(targetDropdownToggle).hide();
            }
        });
    }

    setGlobalCSSVars() {
        const self = this;

        const scrollBarWidth = new ScrollBarHelper().getWidth();
        document.documentElement.style.setProperty('--default-scrollbar-width', scrollBarWidth + 'px');

        // Update the scrollbar width CSS variable value when the window size changes
        window.addEventListener('resize', self.debounce(() => {
            const scrollBarWidth = new ScrollBarHelper().getWidth();
            document.documentElement.style.setProperty('--default-scrollbar-width', scrollBarWidth + 'px');
        }, 200));
    }

    initLitepicker(inputElement) {
        return import(/* webpackChunkName: "Litepicker" */ 'litepicker').then(({ default: Litepicker }) => {
            return import(/* webpackChunkName: "Litepicker-keyboardnav" */ 'litepicker/dist/plugins/keyboardnav').then(({ default: keyboardnav }) => { //eslint-disable-line
                inputElement.parentElement.classList.add('opl-calendar-wrapper');

                return new Litepicker({
                    element: inputElement,
                    parentEl: inputElement.parentElement,
                    format: 'DD/MM/YYYY',
                    plugins: ['keyboardnav'],
                    autoRefresh: true,
                    autoApply: true,
                    firstDay: 0,
                    position: 'bottom',
                    zIndex: 999
                });
            });
        });
    }
}
